<template>
    <div>
<h2 v-if="!effectiveShowGroupMapping">Editeur de règles</h2>

		<p v-if="!effectiveShowGroupMapping"><b>Données initiales</b></p>

		<b-select v-if="!effectiveShowGroupMapping" v-model="type_data_test" :options="[
			{value: 'tabulator', text: 'Tableau'},
			{value: 'database', text: 'Base de données'},
			{value: 'DatabaseRequestView', text: 'Base de données - multitables'},
		]" />

		<b-button
			v-if="!effectiveShowGroupMapping && type_data_test == 'tabulator' && prev_data && prev_data.length > 0"
			variant="link"
			@click="use_prev_data"
			>Utiliser les données de l'étape précédente</b-button>

		<br v-if="!effectiveShowGroupMapping" /><br v-if="!effectiveShowGroupMapping" />

		<div v-if="!effectiveShowGroupMapping && type_data_test == 'tabulator'">
			<edit_tabulator 
				@update="import_file" 
				ref="tabulator" 
				:columns_type="options.images_obj || {}"
			></edit_tabulator>
		</div>

		<DatabaseRequestView v-if="!effectiveShowGroupMapping && type_data_test == 'DatabaseRequestView'"
			@update="import_file"
			_type="db"
			:minimal="true"
			ref="tabulator" />

		<div v-if="!effectiveShowGroupMapping && type_data_test == 'database'">
			<database
				@update="import_file"
				:change_table="true"
				:name="false"
				:edit="false"
				ref="tabulator"></database>
		</div>

		<hr v-if="!effectiveShowGroupMapping" />

		<b v-if="!effectiveShowGroupMapping">Options</b>

		<b-checkbox v-if="!effectiveShowGroupMapping" v-model="options.lowercase">Ignorer la casse dans les conditions</b-checkbox>

		<hr v-if="!effectiveShowGroupMapping && options.images" />

		<b-checkbox v-if="!effectiveShowGroupMapping" v-model="options.images">Images</b-checkbox>

		<div v-if="!effectiveShowGroupMapping && options.images">
			<b-checkbox v-model="options.images_db">Réordonner en fonction de la base de données</b-checkbox>
			<p>
				Colonne des images
				<b-input @change="set_images_column" v-model="options.images_column" />
			</p>			
			<p>
				Changement de poids - blacklist
				<b-input type="number" v-model="options.images_blacklist_weight" />
			</p>			
			<p>
				Changement de poids - whitelist
				<b-input type="number" v-model="options.images_whitelist_weight" />
			</p>
			<hr />
		</div>

		<p v-if="!effectiveShowGroupMapping">Listes <b-button v-b-modal="'list'" variant="link"><i class="fas fa-cogs"></i></b-button></p>

		<b-modal v-if="!effectiveShowGroupMapping" @shown="modal_list_open" ok-only :id="'list'" title="Sélection">
			<div v-for="(list, idx) in options.lists" :key="idx">
				Nom
				<b-input v-model="list.name"></b-input>
				Colonnes - conditions/actions
				<vue-tags-input
					:placeholder="
							'ajouter une colonne'
						"
					style="max-width: 100%; margin-right: 30px"
					obj_words
					v-model="list.column"
					:tags="list.columns"
					:allow-edit-tags="true"
					@tags-changed="(newTags) => (list.columns = newTags)" 
					@before-adding-tag="add_tag($event, list, idx)"
					@before-deleting-tag="delete_tag"
					/>
				Table
				<b-input :list="'table' + idx" v-model="list.table"></b-input>
				<datalist :id="'table' + idx">
					<option v-for="(option, idx) in tables" :key="idx">{{ option }}</option>
				</datalist>
				Colonne de la table
				<b-input v-model="list.column_table"></b-input>
				<b-button @click="generate_list(list, idx)" variant="link">Générer la liste</b-button>
				<edit_tabulator :minimal="true" :extern_file="false" :name="false" :edit="false" :ref="'tabulator' + idx" v-show="list.values && list.values.length > 0"></edit_tabulator>
				<b-button @click="delete_list(list, idx)" variant="link">Supprimer la liste</b-button>
			</div>

			<b-button @click="add_list" variant="link">Ajouter une liste</b-button>
		</b-modal>

		<b v-if="!effectiveShowGroupMapping">Règles</b>

		<rules_block v-if="!effectiveShowGroupMapping" ref="rules" :columns="columns" :options="options"></rules_block>

		<!-- Section mapping de groupes — visible uniquement si show_group_mapping est vrai -->
		<div v-if="effectiveShowGroupMapping" class="mt-2">
			<small class="d-block text-muted mb-3">Pour chaque produit, la <strong>première règle</strong> dont les conditions sont vérifiées détermine le groupe.</small>

			<div v-for="(rule, idx) in groupMapping" :key="idx" class="mb-3 p-2 border rounded" style="background:#f8f9fa">
				<div class="d-flex align-items-center mb-2" style="gap:8px">
					<strong style="min-width:60px; font-size:0.9em">Groupe</strong>
					<b-form-input v-model="rule.groupe" size="sm" placeholder="ex: high-tech, vêtements" :list="'group-mapping-groupes-list'" autocomplete="off" style="max-width:200px" />
					<datalist id="group-mapping-groupes-list">
						<option v-for="g in groupesList" :key="g" :value="g" />
					</datalist>
					<b-button size="sm" variant="outline-danger" class="ml-auto" @click="removeGroupRule(idx)">
						<i class="fas fa-trash"></i> Supprimer
					</b-button>
				</div>
				<div class="query-builder border rounded p-2" style="background:#fff">
					<div v-for="(group, gIdx) in rule.visualRuleGroups" :key="'grg-' + idx + '-' + gIdx">
						<query-builder-group
							:group="group"
							:fields="qbFields"
							:categories-map="categoriesMap"
							:marques-list="marquesList"
							:can-remove="rule.visualRuleGroups.length > 1"
							@remove="rule.visualRuleGroups.splice(gIdx, 1)"
							@open-category="openCategoryForGroupRule($event)"
						/>
						<div v-if="gIdx < rule.visualRuleGroups.length - 1" class="text-center my-1">
							<span class="badge badge-secondary">OU</span>
						</div>
					</div>
					<b-button size="sm" variant="link" class="mt-1" @click="rule.visualRuleGroups.push({ operator: 'ET', conditions: [{ field: 'marque', operator: '==', value: '' }] })">
						+ Ajouter un groupe OU
					</b-button>
				</div>
			</div>

			<b-button size="sm" variant="outline-primary" @click="addGroupRule">
				<i class="fas fa-plus"></i> Ajouter une règle de groupe
			</b-button>
		</div>

		<hr v-if="!effectiveShowGroupMapping" />

		<b-button v-if="!effectiveShowGroupMapping" @click="test">Test</b-button>

		<br v-if="!effectiveShowGroupMapping" /><br v-if="!effectiveShowGroupMapping" />

		<pre v-if="!effectiveShowGroupMapping">{{code}}</pre>

		<div v-if="!effectiveShowGroupMapping && spinner" class="center_spinner">
			<fade-loader></fade-loader>
		</div>

		<p v-if="!effectiveShowGroupMapping"><b>Résultats</b></p>

		<div v-if="!effectiveShowGroupMapping && error">
			Erreur : {{ error }}
		</div>
			
		<edit_tabulator
			v-if="!effectiveShowGroupMapping"
			:extern_file="false"
			ref="result_tabulator"
			:columns_type="options.images_obj || {}">
		</edit_tabulator>

		<div v-if="!effectiveShowGroupMapping && !hide_treatment"><b>Traitement</b> <b-button v-b-modal="'select_project'" variant="link"><i class="fas fa-cogs"></i></b-button></div>

		<b-modal v-if="!effectiveShowGroupMapping && !hide_treatment" ok-only :id="'select_project'" title="Sélection">
			<b-select @change="add_projects_list" :options="projects_options">
			</b-select>

			<div v-for="(project, idx) in projects_list" :key="idx">
				{{ projects_uid[project.value].libelle }} <b-button variant="link" @click="projects_list.splice(idx, 1)"><i class="fas fa-trash"></i></b-button>
			</div>
		</b-modal>

		<div v-if="!effectiveShowGroupMapping && !hide_treatment" v-show="projects_list.length > 0">
			<b-select @change="set_select_project" v-model="project_treatment" :options="projects_list">
			</b-select>
		</div>

		<c_treatment_params v-if="!effectiveShowGroupMapping && !hide_treatment" v-show="project_treatment" ref="treatment_params" :dashboard="false"></c_treatment_params>

		<br v-if="!effectiveShowGroupMapping && !hide_treatment" />

		<b-button
			v-if="!effectiveShowGroupMapping && !hide_treatment"
			:disabled="!project_treatment"
			variant="success"
			v-on:click="start"
			>Démarrer le traitement</b-button>

		<treatment v-if="!effectiveShowGroupMapping && !hide_treatment" ref="myTreatment"></treatment>
    </div>
</template>

<script>
    
	import store from "../store";	
	import users from "../services/users.js";
	import rules_block from "./rules_block.vue";
	import workers from "../services/workers.js";
    import database from "../services/database.js";
	import projects from "../services/projects.js";
	import databaseView from "../views/database.vue";
	import edit_tabulator from "./edit_tabulator.vue";
	import treatments from "../services/treatments.js";
	import treatment from "../components/treatment.vue";
	import c_treatment_params from "../components/params.vue"
    import DatabaseRequestView from '../views/DatabaseRequestView.vue';
	import QueryBuilderGroup from './QueryBuilderGroup.vue';

	import VueTagsInput from "@johmun/vue-tags-input";
	import FadeLoader from "vue-spinner/src/FadeLoader.vue";

    var clone = require("clone");
    const _ = require("underscore");

	export default {
		name: "rules_editor",
		components: {
			rules_block,
			edit_tabulator,
			database: databaseView,
			DatabaseRequestView,
			c_treatment_params,
			FadeLoader,
			treatment,
			VueTagsInput,
			QueryBuilderGroup,
		},
		data() {
			return {
				test_data: [],
				columns: [],
				code: "",
				spinner: false,
				error: "",
				type_data_test: "tabulator",

				projects: [],
				projects_options: [],
				projects_libelle: {},
				projects_uid: {},
				projects_list: [],
				project_treatment: "",
				params: [],
				treatment: null,

				options: {
					lowercase: false,
					lists: [],
					columns_list: {},
					images: false,
					images_db: false,
					images_column: "",
					images_obj: {},
					images_blacklist_weight: -50,
					images_whitelist_weight: 20
				},

				// Mapping de groupes (interface intermédiaire)
				groupMapping: [],
				effectiveShowGroupMapping: false,
				groupTestResults: [],
				groupCondOperators: [
					{ value: '==',       text: '= égal à' },
					{ value: '!=',       text: '≠ différent de' },
					{ value: 'includes', text: 'contient' },
					{ value: '!includes',text: 'ne contient pas' },
					{ value: '>',        text: '>' },
					{ value: '<',        text: '<' },
				],

				tables: []
            }
		},
		props: {
			library: {
				default: false
			},
			prev_data: {
				default: () => []
			},
			hide_treatment: {
				default: false
			},
			show_group_mapping: {
				default: false
			},
			qbFields: {
				default: () => [
					{ value: 'marque', label: 'Marque', type: 'text', useMarquesList: true },
					{ value: 'prix_ht', label: 'Prix HT', type: 'number' },
					{ value: 'prix_ttc', label: 'Prix TTC', type: 'number' },
					{ value: 'categorie', label: 'Catégorie principale', type: 'categorie' },
					{ value: 'categories', label: 'Catégories', type: 'categories' },
				]
			},
			categoriesMap: {
				default: () => ({})
			},
			marquesList: {
				default: () => []
			},
			groupesList: {
				default: () => []
			},
		},
		watch: {
		},
		computed: {
		},
        methods: 
        {
			async set_images_column()
			{
				var self = this;

				this.options.images_obj = {}; 
				this.options.images_obj[this.options.images_column] = {
					type: 'image', 
					black_white_lists: true
				};

				var data = await this.$refs.tabulator.save();
				await this.$refs.tabulator.load([]);
				await this.$refs.tabulator.load(data);
			},
			modal_list_open()
			{
				console.log("open");

				for (var i = 0; i < this.options.lists.length; i++)
				{
					if (this.options.lists[i].results && this.options.lists[i].results.length > 0)
						this.$refs['tabulator' + i][0].load(this.options.lists[i].results);
				}
			},
			async delete_list(list, idx)
			{
				for (var i = 0; i < list.columns.length; i++)
				{
					var value = list.columns[i].text;
					if (this.options.columns_list[value])
						this.$delete(this.options.columns_list, value);
				}				
				this.$delete(this.options.lists, idx);
			},
			async add_tag(tag, list, idx)
			{
				console.log("add")
				
				this.$set(this.options.columns_list, tag.tag.text, list.values);

				tag.addTag();
			},
			async delete_tag(tag)
			{
				console.log("delete")
				console.log(tag)

				if (this.options.columns_list[tag.tag.text])
					this.$delete(this.options.columns_list, tag.tag.text);

				tag.deleteTag();
			},
			async generate_list(list, idx)
			{
				//list = clone(list);

				var results = await database.get("SELECT", list.table, {
					select: "`" + list.column_table + "` AS value",
					end: "group by `" + list.column_table + "` order by `" + list.column_table + "`"
				});

				list.values = [];
				list.results = results;
				var columns = [];
				for (var i = 0; i < list.columns.length; i++)
				{
					var value = list.columns[i].text;
					columns.push(value);
					this.options.columns_list[value] = [];
				}
				for(var i = 0; i < results.length; i++)
				{
					var value = results[i].value;
					list.values.push(value);
					for (var j = 0; j < columns.length; j++)
					{
						this.options.columns_list[columns[j]].push(value);
					}
				}

				this.$refs['tabulator' + idx][0].load(results);
				this.$set(this.options.lists, idx, list);
			},
			async add_list()
			{
				this.options.lists.push({
					name: "",
					columns: [],
					nb: 0
				})	
			},
			async start()
			{
				await this.save();

				var csv = await this.$refs.tabulator.get_data_blob();

				var res = await treatments
				.create(
					this.project_treatment,
					null,
					csv,
					"data.csv",
					"",
					"import",
					null,
					this.$refs.treatment_params.get()
				).catch((err) => {
                    console.log("error : " + err);
                    this.$notify({
                        group: "info",
                        title: err.response.data.msg,
                        type: "error",
                    });
                });

				console.log(res)

				this.$refs.myTreatment.start(
					res.treatment.uid,
					false,
					2000
				);
			},
			async set_select_project()
			{
				this.params = [],
				this.treatment_params = this.projects_uid[this.project_treatment].details.treatment_params || [];
				console.log(this.treatment_params)
				await this.$refs.treatment_params.set(this.treatment_params);
			},
			async add_projects_list(value)
			{
				console.log(value)
				var text = this.projects_uid[value].libelle
				if (!this.projects_list.some(item => item.value === value))
					this.projects_list.push({value: value, text: text});
			},
			async load_data(data)
			{
				var self = this;
				this.type_data_test = "tabulator"

				self.$nextTick(async function () {
					self.$refs.tabulator.load(data);
				});
			},
			async load(data, reduce)
			{
				var self = this;

				// Auto-détecter le mode groupe si les données viennent du scraping
				if (data.group_mapping && data.group_mapping.length && !data.rules) {
					this.effectiveShowGroupMapping = true;
				}

				if (data.type_data_test)
					this.type_data_test = data.type_data_test;
				else
					this.type_data_test = "tabulator"

				if (this.$refs.rules) this.$refs.rules.load(data.rules);

				this.projects_list = data.projects_list || [];

				if (data.options)
					this.options = data.options;

				// Restaurer le mapping de groupes (avec migration ancien format → visualRuleGroups)
				if (data.group_mapping) {
					this.groupMapping = data.group_mapping.map(rule => {
						// Ancien format : {groupe, conditions:[...]} → nouveau : {groupe, visualRuleGroups:[{operator:'ET', conditions:[...]}]}
						if (!rule.visualRuleGroups && rule.conditions) {
							return { groupe: rule.groupe, visualRuleGroups: [{ operator: 'ET', conditions: rule.conditions }] };
						}
						return rule;
					});
				}

                self.$nextTick(async function () {
					if (data.test_data && self.$refs.tabulator)
					{
						self.$refs.tabulator.load(data.test_data);
					}
				});
			},
			async save()
            {
				var rules = this.$refs.rules ? this.$refs.rules.save() : null;
				var code = this.$refs.rules ? await this.generate_code() : '';
				var data = null;
				
				if (this.$refs.tabulator) {
					data = await this.$refs.tabulator.save();
					if (this.type_data_test == "tabulator")
						data = data.slice(0, 10);
				}

				return {
					code,
					test_data: data,
					rules,
					type_data_test: this.type_data_test,
					projects_list: this.projects_list,
					options: this.options,
					group_mapping: this.groupMapping,
					data_db: {
						image: this.options.images ? true : false
					}
				}
			},
			openCategoryForGroupRule(rule) {
				// Déléguer la sélection de catégorie au composant parent (scraping_core)
				this.$emit('open-category', rule);
			},
			addGroupRule() {
				this.groupMapping.push({
					groupe: '',
					visualRuleGroups: [{ operator: 'ET', conditions: [{ field: 'marque', operator: '==', value: '' }] }]
				});
			},
			removeGroupRule(idx) {
				this.groupMapping.splice(idx, 1);
			},
			generateGroupCode() {
				// En mode show_group_mapping, la fonction est construite par scraping_core via _buildGroupFnFromRules
						if (this.effectiveShowGroupMapping) return;
				if (!this.groupMapping.length) return;
				const lines = [
					"// [Généré par l'interface de groupes de scraping]",
					"var set_group = function(data) {"
				];
				for (const rule of this.groupMapping) {
					if (!rule.groupe || !rule.groupe.trim()) continue;
					const conds = rule.conditions
						.filter(c => c.field && c.field.trim())
						.map(c => {
							const f = `data['${c.field}']`;
							const v = isNaN(c.value) ? `'${String(c.value).replace(/'/g, "\\'")}'` : c.value;
							if (c.operator === 'includes')  return `(String(${f}||'').includes(${v}))`;
							if (c.operator === '!includes') return `(!String(${f}||'').includes(${v}))`;
							return `(${f} ${c.operator} ${v})`;
						});
					const cond = conds.length ? conds.join(' && ') : 'true';
					lines.push(`    if (${cond}) return '${rule.groupe.replace(/'/g, "\\'")}';`);
				}
				lines.push('    return null;');
				lines.push('};');
				lines.push('data.groupe = set_group(data);');
				const generatedCode = lines.join('\n');
				// Injecter dans le premier bloc code de rules_block si présent
				const rulesData = this.$refs.rules.save();
				if (
					rulesData &&
					rulesData.rules_blocks &&
					rulesData.rules_blocks.length === 1 &&
					rulesData.rules_blocks[0].rules_blocks &&
					rulesData.rules_blocks[0].rules_blocks.length === 1 &&
					rulesData.rules_blocks[0].rules_blocks[0].type_action === 'code'
				) {
					rulesData.rules_blocks[0].rules_blocks[0].params.code = generatedCode;
					this.$refs.rules.load(rulesData);
				}
			},
			async testGroupMapping() {
				this.groupTestResults = [];
				let rows = [];
				try { rows = await this.$refs.tabulator.save(); } catch(e) {}
				if (!rows || !rows.length) return;
				const fnBody = [
					'var set_group = function(data) {',
					...this.groupMapping
						.filter(r => r.groupe && r.groupe.trim())
						.map(rule => {
							const conds = rule.conditions
								.filter(c => c.field && c.field.trim())
								.map(c => {
									const f = `data['${c.field}']`;
									const v = isNaN(c.value) ? `'${String(c.value).replace(/'/g, "\\'")}'` : c.value;
									if (c.operator === 'includes')  return `(String(${f}||'').includes(${v}))`;
									if (c.operator === '!includes') return `(!String(${f}||'').includes(${v}))`;
									return `(${f} ${c.operator} ${v})`;
								});
							const cond = conds.length ? conds.join(' && ') : 'true';
							return `    if (${cond}) return '${rule.groupe.replace(/'/g, "\\'")}';`;
						}),
					'    return null;',
					'};',
					'return set_group(data);'
				].join('\n');
				let fn;
				try { fn = new Function('data', fnBody); } catch(e) { return; }
				this.groupTestResults = rows.slice(0, 20).map((row, i) => ({
					label: row.nom || row.cle_externe || row.nom_fr || `Ligne ${i + 1}`,
					groupe: (() => { try { return fn(row); } catch(e) { return null; } })()
				}));
			},
			import_file()
			{
				this.test_data = this.$refs.tabulator.get_data();

				if (this.test_data.length > 0)
				{
					this.columns = Object.keys(this.test_data[0]);
				}
				else
				{
					this.columns = []
				}

				if (this.options.images)
				{
					this.columns = this.columns.concat([
						"uid",
						"url",
						"link",
						"title",
						"width",
						"height",
						"source",
						"get_date",
						"position",
						"domain",
						"state"
					]);
				}
			},
			async use_prev_data()
			{
				if (!this.prev_data || this.prev_data.length == 0)
					return;

				await this.$refs.tabulator.load(clone(this.prev_data));
				this.import_file();
			},
			async generate_code()
			{
				var code = await this.$refs.rules.generate_code();

				return code;
			},
			async test()
			{
				this.spinner = true;
				this.error = ""

				this.$refs.result_tabulator.load([]);
				var code = await this.generate_code();

				this.code = code;

				let files = await this.$refs.tabulator.get_data_files();
				var formData = new FormData();
				formData.append(files[0].name, files[0]);
				
				if (this.options.images)
				{
					formData.append("action", "blacklist_whitelist");
					formData.append("parameters", JSON.stringify({
							code_rules: code,
							column: this.options.images_column,
							db: this.options.images_db,
							blacklist_weight: this.options.images_blacklist_weight,
							whitelist_weight: this.options.images_whitelist_weight
					}));
				}
				else
				{
					formData.append("action", "fonction");
					formData.append("parameters", JSON.stringify({
							code: code,
							raw: "line"
					}));
				}

				var data = await workers.test(formData);

				console.log(data)

				if (data.data.error)
					this.error = data.data.error;

				if (data.data.files.length > 0)
				{
					var csv_data = await treatments.getFileAlyx(
						data.data.files[0].url,
						false,
						false
					);
					var data  = this.$papa.parse(csv_data, {
						header: true,
					});
					data = data.data;

					console.log("data")
					console.log(data)

					this.$refs.result_tabulator.load(data);
				}

				this.spinner = false;
			}
		},
		mounted: async function () {
            var self = this;
			this.effectiveShowGroupMapping = this.show_group_mapping;
			this.projects = await projects.getAll(false, true, null, true);
			for (var i = 0; i < this.projects.length; i++) {
				this.projects_options.push({
					value: this.projects[i].uid,
					text: this.projects[i].libelle
				})
				this.projects_libelle[this.projects[i].libelle] =
					this.projects[i];
				this.projects_uid[this.projects[i].uid] =
					this.projects[i];
			}

			let response = await users.getSelf(true);
			this.client = response.client;

			var tables = [];
			if (this.client.details && this.client.details.tables)
				tables = this.client.details.tables;

			if (tables && tables.length > 0) {
				for (var i = 0; i < tables.length; i++) {
					this.tables.push(tables[i].name);
				}
			}
		},
	};
</script>

<style>
.is-hidden {
    display: none;
}
.center_spinner {
	width: 0%;
	margin: 0 auto;
	margin-top: 30px;
}
</style>